import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./NavBar.css";
import logo from "../assets/logo.png";

function NavBar() {
  const [navOpen, setNavOpen] = useState(false);

  // Dropdown toggles
  const [collectionsOpen, setCollectionsOpen] = useState(false);
  const [paymentsOpen, setPaymentsOpen] = useState(false);
  const [clientsOpen, setClientsOpen] = useState(false);
  const [therapistOpen, setTherapistOpen] = useState(false);

  // NEW: For therapist's "Clients" dropdown
  const [therapistClientOpen, setTherapistClientOpen] = useState(false);

  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const userData =
    token && localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null;

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  // Close entire menu + any open dropdown
  const closeAllMenus = () => {
    setNavOpen(false);
    setCollectionsOpen(false);
    setPaymentsOpen(false);
    setClientsOpen(false);
    setTherapistOpen(false);
    setTherapistClientOpen(false);
  };

  return (
    <header className="navbar">
      {/* Brand */}
      <div className="brand">
        <NavLink to="/" className="brand-link" onClick={closeAllMenus}>
          <img src={logo} alt="Therapy Portal Logo" className="brand-logo" />
          Therapy Portal
        </NavLink>
      </div>

      {/* Hamburger for mobile */}
      <button
        className="hamburger-button"
        onClick={toggleNav}
        aria-label="Toggle navigation menu"
      >
        &#9776;
      </button>

      <nav className={`nav-links ${navOpen ? "open" : ""}`}>
        {/* If not logged in */}
        {!token && (
          <NavLink
            to="/"
            end
            className={({ isActive }) => (isActive ? "active-link" : "")}
            onClick={closeAllMenus}
          >
            Login
          </NavLink>
        )}

        {/* THERAPIST LINKS */}
        {token && userData?.role === "THERAPIST" && (
          <>
            <NavLink
              to="/therapist/dashboard"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={closeAllMenus}
            >
              Therapist Dashboard
            </NavLink>
            <NavLink
              to="/therapist/messages"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={closeAllMenus}
            >
              Messages
            </NavLink>
            <NavLink
              to="/therapist/daily-log-multi"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={closeAllMenus}
            >
              Multi Log
            </NavLink>
            <NavLink
              to="/therapist/debt"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={closeAllMenus}
            >
              Debt Sessions
            </NavLink>
            <NavLink
              to="/therapist/pay-history"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={closeAllMenus}
            >
              Pay History
            </NavLink>
            <NavLink
              to="/therapist/tools"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={closeAllMenus}
            >
              Tools
            </NavLink>
            <NavLink
              to="/therapist/resources"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={closeAllMenus}
            >
              Resources
            </NavLink>

            {/* NEW CLIENTS DROPDOWN FOR THERAPIST */}
            <div className="dropdown">
              <button
                className="dropbtn"
                onClick={() => setTherapistClientOpen(!therapistClientOpen)}
              >
                Clients
              </button>
              {therapistClientOpen && (
                <div className="dropdown-content">
                  <NavLink to="/therapist/client-profile" onClick={closeAllMenus}>
                    Client Profile
                  </NavLink>
                  <NavLink to="/therapist/notes" onClick={closeAllMenus}>
                    Notes
                  </NavLink>
                </div>
              )}
            </div>
          </>
        )}

        {/* ADMIN LINKS */}
        {token &&
          userData &&
          (userData.role === "OFFICE_ADMIN" || userData.role === "PORTAL_ADMIN") && (
            <>
              <NavLink
                to="/admin/dashboard"
                className={({ isActive }) => (isActive ? "active-link" : "")}
                onClick={closeAllMenus}
              >
                Admin Dashboard
              </NavLink>

              <NavLink
                to="/admin/messages"
                className={({ isActive }) => (isActive ? "active-link" : "")}
                onClick={closeAllMenus}
              >
                Messages
              </NavLink>

              {/* COLLECTIONS DROPDOWN */}
              <div className="dropdown">
                <button
                  className="dropbtn"
                  onClick={() => setCollectionsOpen(!collectionsOpen)}
                >
                  Collections
                </button>
                {collectionsOpen && (
                  <div className="dropdown-content">
                    <NavLink to="/admin/payment" onClick={closeAllMenus}>
                      Credit Card Payment
                    </NavLink>
                    <NavLink to="/admin/debt-records" onClick={closeAllMenus}>
                      Debt Records
                    </NavLink>
                    <NavLink to="/admin/daily-report" onClick={closeAllMenus}>
                      Daily Report
                    </NavLink>
                  </div>
                )}
              </div>

              {/* PAYMENTS DROPDOWN */}
              <div className="dropdown">
                <button
                  className="dropbtn"
                  onClick={() => setPaymentsOpen(!paymentsOpen)}
                >
                  Payments
                </button>
                {paymentsOpen && (
                  <div className="dropdown-content">
                    <NavLink to="/admin/payroll" onClick={closeAllMenus}>
                      Payroll
                    </NavLink>
                    <NavLink to="/admin/bonuses" onClick={closeAllMenus}>
                      Bonuses
                    </NavLink>
                  </div>
                )}
              </div>

              {/* CLIENTS DROPDOWN */}
              <div className="dropdown">
                <button
                  className="dropbtn"
                  onClick={() => setClientsOpen(!clientsOpen)}
                >
                  Clients
                </button>
                {clientsOpen && (
                  <div className="dropdown-content">
                    <NavLink to="/admin/invoice" onClick={closeAllMenus}>
                      Invoice
                    </NavLink>
                    <NavLink to="/admin/clients" onClick={closeAllMenus}>
                      Client Profile
                    </NavLink>
                    <NavLink to="/admin/intake-link" onClick={closeAllMenus}>
                      New Client Intake
                    </NavLink>
                  </div>
                )}
              </div>

              {/* THERAPIST DROPDOWN */}
              <div className="dropdown">
                <button
                  className="dropbtn"
                  onClick={() => setTherapistOpen(!therapistOpen)}
                >
                  Therapist
                </button>
                {therapistOpen && (
                  <div className="dropdown-content">
                    <NavLink to="/admin/new-user" onClick={closeAllMenus}>
                      New User
                    </NavLink>
                    <NavLink to="/admin/users" onClick={closeAllMenus}>
                      Users
                    </NavLink>
                  </div>
                )}
              </div>

              <NavLink
                to="/admin/tools"
                className={({ isActive }) => (isActive ? "active-link" : "")}
                onClick={closeAllMenus}
              >
                Tools
              </NavLink>
            </>
          )}
      </nav>

      {/* Logout button if logged in */}
      {token && (
        <button className="logout-button" onClick={handleLogout}>
          Logout
        </button>
      )}
    </header>
  );
}

export default NavBar;
